import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const DSDModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'CAT-2', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      {
        name: 'Boolean Algebra: Basic definitions, Axiomatic definition of Boolean Algebra, Basic Theorems and Properties of Boolean Algebra',
        path: '/dsd-m1-s1'
      },
      {
        name: 'Boolean Functions, Canonical and Standard Forms',
        path: '/dsd-m1-s2'
      },
      {
        name: 'Simplification of Boolean functions. Gate-Level Minimization: The Map Method (K-map up to 4 variable), Product of Sums and Sum of Products Simplification',
        path: '/dsd-m1-s3'
      },
      {
        name: 'NAND and NOR Implementation',
        path: '/dsd-m1-s4'
      },
      {
        name: 'Logic Families: Digital Logic Gates, TTL and CMOS logic families',
        path: '/dsd-m1-s5'
      }
    ],
    'Module 2': [
      {
        name: 'Verilog HDL',
        path: '/dsd-m2-s1'
      }
    ],
    'Module 3': [
      {
        name: 'Design Procedure, Half Adder, Full Adder, Half Subtractor, Full Subtractor',
        path: '/dsd-m3-s1'
      },
      {
        name: 'Decoders, Encoders and applications',
        path: '/dsd-m3-s2'
      },
      {
        name: 'Multiplexers and De multiplexers',
        path: '/dsd-m3-s3'
      },
      {
        name: 'Parity generator and checker',
        path: '/dsd-m3-s4'
      },

    ],
    'CAT-2': [
      {
        name: 'Half Adder,Full Adder',
        path: '/dsd-mc-s1'
      },
      {
        name: 'N-bit Adder',
        path: '/dsd-mc-s2'
      },
      {
        name: '4-bit Adder and Subtractor',
        path: '/dsd-mc-s3'
      },
      {
        name: 'MUX,DEMUX',
        path: '/dsd-mc-s4'
      },
      {
        name: 'Decoder encoder',
        path: '/dsd-mc-s5'
      },
      {
        name: 'Priority Encoder',
        path: '/dsd-mc-s6'
      },
      {
        name: 'Array Multiplier and Booth multiplier',
        path: '/dsd-mc-s7'
      },
      {
        name: 'Flip Flops',
        path: '/dsd-mc-s8'
      },
      {
        name: 'Design of Counters',
        path: '/dsd-mc-s9'
      },


    ],
    'Module 6': [
      {
        name: 'Finite State Machines (Mealy & Moore) and Sequence Detection',
        path: '/dsd-m6-s1'
      }
    ],
    'Module 7': [
      {
        name: 'Programmable Logic Devices: PLA, PAL, CPLD, FPGA',
        path: '/dsd-m7-s1'
      }
    ],


    // Keep empty modules for now (You can fill these later)

  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Digital System Design</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-DSDModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DSDModules;
